import angular from 'angular';

class TemplateService {
  constructor($http, $q, $rootScope, $timeout, $compile) {
    this._$http = $http;
    this._$q = $q;
    this._$rootScope = $rootScope;
    this._$timeout = $timeout;
    this._$compile = $compile;
  }

  /**
   * @param {String} templatePath
   * @return {Promise<String>}
   */
  getTemplate(templatePath) {
    if (!templatePath) throw new Error('templateService - getTemplate() - templatePath is required');

    return this._$http.get(templatePath, {
        cache: true
      })
      .then(response => response.data)
      .catch(() => {
        throw new Error(`error getting template : ${templatePath}`);
      });
  }

  /**
   * @param {String} templateHtml
   * @param {Object} data
   * @return {Promise<String>}
   */
  compileTemplate(templateHtml, data) {
    if (!templateHtml) throw new Error('templateService - compileTemplate() - templateHtml is required');
    if (!data) throw new Error('templateService - compileTemplate() - data is required');

    const scope = this._$rootScope.$new();

    angular.extend(scope, data);

    const compiledHtml = this._$compile(templateHtml)(scope);

    return this._$q(resolve => {
      this._$timeout(() => {
        return resolve(compiledHtml);
      });
    });
  }
}

TemplateService.$inject = [
  '$http',
  '$q',
  '$rootScope',
  '$timeout',
  '$compile'
];

export default TemplateService;



// WEBPACK FOOTER //
// ./src/services/templateService.js